import fork from '@haaretz/l-fork.macro';
import { countryCode as countryCodeFallback } from '@haaretz/s-consts';

import type { MiddlewareParams } from '@haaretz/s-types';

export default function countryCodeDispenserMiddleware({ ctx }: MiddlewareParams) {
  const countryCode = fork({
    default: countryCodeFallback,
    hdc: ctx.req.headers.country_code || countryCodeFallback,
  });
  ctx.query.countryCode = countryCode;

  return Promise.resolve({ countryCode });
}
